// generates a negative descending int. unique (per browser session)
let _uid = -1;
export const uid = (): number => _uid--;

// generates a (globally) unique string id
export const uniqueId = (): string => String(Math.floor(Math.random() * 1000000));
